import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import shopContext from "src/context/shopContext";
import { TbTimelineEventText } from "react-icons/tb";
import { RxExternalLink } from "react-icons/rx";

import { numberWithCommas } from "src/utils/thousandSeprator";
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import moment from 'jalali-moment';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { Helmet } from "react-helmet";

export default function SalesVelocityStatistics() {
    const [productVelocityData, setProductVelocityData] = useState();
    const [productEntries, setProductEntries] = useState()
    const [aggregatedData, setAggregatedData] = useState()

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        // گرفتن داده‌ها با هندل خطا
        getData(setProductVelocityData, "/stocklog/salesVelocityStatistics", {}, signal);

        // برای /opbodoroj هندل خطا بذار
        getData(
            (data) => setProductEntries(data),
            "/opbodoroj",
            {},
            signal
        ).catch((err) => {
            console.error("خطا در دریافت اطلاعات api انبار:", err);
            // در صورت خطا مقدار خالی بذار تا صفحه کرش نکنه
            setProductEntries([]);
        });

        return () => {
            controller.abort();
        };
    }, []);


    const [rowData, setRowData] = useState();
    const [isTimeLineModalActive, setIsTimeLineModalActive] = useState(false)


    useEffect(() => {
        if (productVelocityData) {
            let temp = productVelocityData.map(product => ({
                ...{
                    ...product,
                    productBrand: product.brand,
                },
                ...(productEntries?.find(productEntry => productEntry.sku == product.sku) || {})
            }));

            temp = temp.map(productData => {
                let oldestStock = -1;
                let remainStock = productData.stock_quantity;
                productData.entrySummary && productData.entrySummary.forEach((element, index) => {
                    remainStock -= element.order_count;
                    if (remainStock <= 0 && oldestStock == -1) {
                        oldestStock = index;
                    }
                });
                return {
                    ...productData,
                    oldestStock: oldestStock > 0 ? productData.entrySummary[oldestStock].order_date : null
                };
            });
            setAggregatedData(temp);
        }
    }, [productVelocityData, productEntries]);




    const columns = [
        {
            id: "image",
            cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={info.getValue()} />),
            header: "تصویر",
            inExport: false
        },
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "name",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام محصول",
        },
        {
            id: "sku",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "sku",
        },
        // {
        //     id: "global_unique_id",
        //     cell: (info) => info.getValue() ? info.getValue() : "---",
        //     header: "بارکد",
        // },
        // {
        //     id: "regular_price",
        //     cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
        //     header: "قیمت مصرف کننده",
        // },
        // {
        //     id: "sale_price",
        //     cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
        //     header: "قیمت فروش ویژه",
        // },
        {
            id: "categoriesString",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "دسته بندی",
        },
        {
            id: "tagsString",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "برچسب",
        },
        {
            id: "productBrand",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "برند",
        },
        // {
        //     id: "brand",
        //     cell: (info) => info.getValue() ? info.getValue() : "---",
        //     header: "برند داشبورد انبار",
        // },
        {
            id: "suppliers",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تامین کننده",
        },
        {
            id: "oldestStock",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "ورود به انبار قدیمی‌ترین موجودی",
        },
        {
            id: "stock_quantity",
            cell: (info) => parseInt(info.getValue()) > -1 ? info.getValue() : "0",
            header: "موجودی",
        },
        {
            id: "availableTime",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تعداد روزهای موجود",
        },
        {
            id: "totalSales",
            cell: (info) => info.getValue() >= 0 ? info.getValue() : "---",
            header: "مجموع تعداد فروش",
        },
        {
            id: "dailySalesRate",
            cell: (info) => info.getValue() >= 0 ? info.getValue() + " کالا در روز" : "---",
            header: "نرخ فروش (در روز)",
        },
        {
            id: "daysPerSale",
            cell: (info) => info.getValue() >= 0 ? info.getValue() + " روز" : "---",
            header: "فاصله دو فروش",
        },
        {
            id: "attractivenessScore",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نرخ جذابیت",
        },
        {
            id: "daysNeedToOrderNewStocks",
            cell: (info) => (
                <MiniInfoButton text={info.row.original.nextOrderingDate != "-"
                    ? moment
                        .from(info.row.original.nextOrderingDate, "en", "YYYY-MM-DD HH:mm:ss")
                        .locale("fa")
                        .format("jYYYY/jMM/jDD")
                    : "---"} color={info.row.original.daysNeedToOrderNewStocksColor} />
            ),
            header: "تاریخ پیشنهادی سفارش گذاری بعدی",
        },

        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    <a
                        title="لینک محصول"
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                        target="_blank"
                        href={info.row.original.permalink}
                    >
                        <RxExternalLink className="text-blue-500" />
                    </a>
                    {
                        info.row.original.stockTimeLine
                        &&
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setRowData(info.row.original)
                                setIsTimeLineModalActive(true)
                            }}
                        >
                            <TbTimelineEventText className="text-purple-500" />
                        </div>
                    }
                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        },
    ];

    return (
        <>
            <PageHeader
                title="آمار سرعت فروش محصولات"
            // btnTitle="بروزرسانی"
            // isBtnLoading={!productVelocityData}
            // handleClick={async () => {
            //     await getData(() => { }, "/stocklog/salesVelocityStatistics/purgeCache");
            //     await getData(setProductVelocityData, "/stocklog/salesVelocityStatistics")
            // }}
            />
            <Table data={aggregatedData} columns={columns} CSVExportPermission="exportMarketingSalesVelocity" tableName="salesRate" />
            <Modal isOpen={isTimeLineModalActive} toggle={setIsTimeLineModalActive}>
                <ModalHeader>تایم لاین تغییرات موجودی</ModalHeader>
                <ModalBody>
                    <div style={{ direction: "ltr" }}>
                        <Timeline position="alternate">
                            {
                                rowData?.stockTimeLine && rowData.stockTimeLine.map((timelineItem) => {
                                    return (
                                        <TimelineItem>
                                            <TimelineOppositeContent color="text.secondary">
                                                {moment
                                                    .from(timelineItem.loggedAt, "en", "YYYY-MM-DD HH:mm:ss")
                                                    .locale("fa")
                                                    .format("jYYYY/jMM/jDD HH:mm")}
                                            </TimelineOppositeContent>
                                            <TimelineSeparator>
                                                <TimelineDot />
                                                <TimelineConnector />
                                            </TimelineSeparator>
                                            <TimelineContent>{timelineItem.status == "instock" ? "موجود در انبار" : "ناموجود"} ({timelineItem.quantity})</TimelineContent>
                                        </TimelineItem>
                                    )
                                })
                            }
                        </Timeline>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={false}
                        rejectHandle={() => { setIsTimeLineModalActive(false) }}
                        rejectTitle="بستن"
                        isCompact={true}
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}
